import React from 'react';
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import { AuthProvider } from './contexts/AuthContext';
import AppLayout from './components/layout/AppLayout';
import LoginPage from './pages/LoginPage';
import OidcCallbackPage from './pages/OidcCallbackPage';
import { ROUTES } from './navigation/routes';
import { ROUTE_ELEMENTS } from './navigation/routeElements';
import './App.css';
import './components/layout/layout.css';
import './components/ui/ui.css';
import './linkedin/flow.css';
import './vertrieb/vertrieb.css';
import './inhalte/inhalte.css';
import './verwaltung/verwaltung.css';
import './erp/erp.css';
import './design-system-overrides.css';

/**
 * Oeffentliche Routen (Login, Keycloak-Callback) stehen fuer sich; alles
 * andere liegt unter der geschuetzten Layout-Route mit Seitenleiste. Die
 * Routen kommen aus der Registry (src/navigation/routes.ts), damit Sidebar,
 * Palette und Brotkrumen dieselbe Liste sehen.
 */
function App() {
  return (
    <Router>
      <AuthProvider>
        <Routes>
          <Route path="/login" element={<LoginPage />} />
          {/* Keycloak redirect target (OIDC_REDIRECT_URI in env.js) */}
          <Route path="/oidc/callback" element={<OidcCallbackPage />} />

          <Route element={<AppLayout />}>
            {ROUTES.map((entry) => (
              <Route key={entry.id} path={entry.path} element={ROUTE_ELEMENTS[entry.id]} />
            ))}
          </Route>
        </Routes>
      </AuthProvider>
    </Router>
  );
}

export default App;
